import React from "react";
import BaseButton from "./BaseButton";
import { FilterOutlined } from '@ant-design/icons';

const BaseFilterButton = (props) =>
  <BaseButton className="filters-button" { ...props }><FilterOutlined />{ props.text ? props.text : "Filters" }</BaseButton>

export default BaseFilterButton;
